<div class="row filter-type-selection-header">
  <div class="col-6">By Size</div>
  <div class="col-6 text-right">{{ filter.categorySelection?.length || 0 }} Selected</div>
</div>
<div class="row filter-type-selection-body">
  <div class="col-6">
    <p-tree
      [value]="companyCategories"
      (click)="formDirty = true"
      [(selection)]="filter.categorySelection"
      selectionMode="checkbox"
      (onNodeSelect)="sortSelection(filter.categorySelection)"
      emptyMessage="No records found"
    ></p-tree>
  </div>
  <div class="col-6">
    <p-tree
      [value]="filter.categorySelection"
      (click)="formDirty = true"
      [(selection)]="filter.categorySelection"
      selectionMode="multiple"
      selectionMode="checkbox"
      emptyMessage=" "
    ></p-tree>
  </div>
</div>
<!-- p-tree does not have implementation of value control accessor the hack below implements this -->
<fieldset ngModelGroup="”accountTypes”">
  <input type="hidden" [(ngModel)]="filter.categorySelection" name="categorySelectionfield" #categorySelectionfield="ngModel" required />
  <div class="row">
    <div class="col=12">
      <span class="help-block">
        <span *ngIf="formDirty && categorySelectionfield.invalid"> Please select an option </span>
      </span>
    </div>
  </div>
</fieldset>
